import OrdersPageLink from './OrdersPageLink';

export default OrdersPageLink;
